<template>
  <form class="t-withdrawal" @submit.prevent="Submit()" method="post">
    <h2>{{ balanceText.withdrawalTitle }}</h2>
    <div class="t-input" :class="{_error: countError}">
      <label>{{ balanceText.withdrawalLabel }}</label>
      <input v-model="count" @input="InputCount">
    </div>
    <!-- <div class="t-withdrawal__currency">
      <span>{{ exchangeRates }}</span>
      <div class="t-withdrawal-currency t-input">
        <v-select v-model="currency.value"
                  :options="currency.options"
                  :searchable="false"
                  :filterable="false"></v-select>
      </div>
    </div> -->
    <div class="t-withdrawal__hint">
      {{ balanceText.withdrawalHint }}
    </div>
    <div class="t-input" :class="{_error: commentsError}">
      <label>{{ balanceText.comment }}</label>
      <textarea-autosize v-model="comments" :min-height="81"  @input="ClearError()"></textarea-autosize>
      <p>{{ balanceText.commentHint }}</p>
    </div>
    <button class="t-btn"><span>{{ balanceText.withdrawalBtn }}</span></button>
  </form>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {store} from '../../store'
    export default {
        data(){
            return {
                count: '',
                countError: false,
                comments: '',
                commentsError: false,
                // currency: {
                //     label: store.getters['staticText/balanceText'].confirmLabel,
                //     name: "currency",
                //     value: [],
                //     error: false,
                //     options: []
                // }
            }
        },
        computed: {
            ...mapGetters('staticText', ['balanceText']),
            // ...mapGetters('handbook', ['currencyList']),
            // exchangeRates(){
            //     if(this.count !== ''){
            //         let a = parseFloat(this.count) * parseFloat(this.currency.value.exchangeRates) + '';

            //         a = a.split('.');
            //         a[0] = a[0].replace(/(\d{1,3})(?=((\d{3})*([^\d]|$)))/g, " $1");
            //         if(a[1])
            //             a[1] = a[1].substring(0,2);
            //         a = a.join('.');

            //         return a;
            //     }

            //     return 0
            // }
        },
        methods: {
            ...mapActions('modal', ['modalDialogClose']),
            ...mapActions('msg', ['showMsg']),
            ...mapActions('profile', ['LoadBalance']),
            InputCount(){
                this.countError = false;
                this.count = this.count.replace(/[^\d,.]/g, "");
            },
            ClearError(){
                this.commentsError = false;
            },
            Submit(){
                let is_valid = true;

                if(this.count === '' || this.count < 1){
                    this.countError = true;
                    is_valid = false;
                }
                if(this.comments === ''){
                    this.commentsError = true;
                    is_valid = false;
                }

                if(is_valid){
                    let fd = new FormData();

                    fd.append('count', this.count);
                    // fd.append('currency', this.currency.value.value);
                    fd.append('comments', this.comments);

                    this.$http.post('withdrawal', fd)
                        .then(response => {
                            if(response.body.success){
                                this.LoadBalance();
                                this.modalDialogClose();
                                this.showMsg(this.balanceText.msg);
                            } else{
                                let text = '';
                                for(let key in response.body.errors){
                                    text += response.body.errors[key]
                                }
                                for(let i = 0; i < this.form.length; i++){
                                    this.form[i].error = true;
                                }
                                this.showMsg(text)
                            }
                        }, response => {
                            this.modalDialogClose();
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        });
                }
            }
        },
        // mounted(){
        //     for(let i = 0; i < this.currencyList.length; i++){
        //         this.currency.options.push(Object.assign({},this.currencyList[i],{label: this.currencyList[i].title}))
        //     }
        //     this.currency.value = Object.assign({},this.currencyList[0],{label: this.currencyList[0].title});
        // }
    }
</script>

<style lang="sass">
.t-withdrawal
  width: 320px
  padding: 24px
  margin: 0 auto
  line-height: 1.2
  @extend %substrate
  .t-input
    margin-bottom: 12px
    p
      margin-top: 12px
  &__currency
    display: flex
    align-items: center
    margin-bottom: 10px
    > span
      padding-left: 16px
      color: $blue
      font-size: 22px
      font-weight: bold
  &__hint
    position: relative
    margin-bottom: 24px
    padding-left: 40px
    &:before
      content: '!'
      position: absolute
      left: 0
      top: 50%
      transform: translateY(-50%)
      font-size: 96px
      color: $blue
      pointer-events: none
.t-withdrawal-currency
  &.t-input
    width: auto
    margin: 0 0 0 auto
    .v-select
      .selected-tag
        color: $blue
      .dropdown-toggle
        background: #FFFFFF
        box-shadow: 0 24px 48px rgba(0, 108, 202, 0.2)
        border-radius: 16px
      &.open.single .selected-tag
        display: block
</style>


// WEBPACK FOOTER //
// src/vue_components/ModalDialog/Withdrawal.vue